import type { UpdateProfileBody } from '@/redux/internal-services/usersApi';

/** The Voice & Interaction step's two choices, as stored on the user profile. */
export type OnboardingInteractionMode = 'text' | 'voice';

/**
 * Build the updateMe payload for the onboarding Voice & Interaction step.
 *
 * BOTH fields must be sent: `interaction_mode` was previously omitted on every onboarding
 * finish path (only `voice_gender` went out), so a user who explicitly picked "Voice & Text"
 * still resolved to text — the backend's _to_profile falls back to the tenant/system
 * `default_interaction_mode` when the user-layer config has no `interaction_mode`. Settings →
 * TenantSettingsPage always sent it, so the two screens disagreed.
 *
 * `voice_gender` is deliberately left undefined in text mode: update_profile drops None/absent
 * keys, so a text-only user keeps whatever voice the tenant default resolves to rather than
 * pinning one they never chose.
 */
export function buildVoicePrefsPayload(
  interactionMode: OnboardingInteractionMode,
  voiceGender: 'male' | 'female' | null | undefined,
): Pick<UpdateProfileBody, 'interaction_mode' | 'voice_gender'> {
  return {
    interaction_mode: interactionMode,
    voice_gender: interactionMode === 'voice' ? voiceGender ?? undefined : undefined,
  };
}
